// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:07:13

export default {
  "id": "robbie-become-a-beast",
  "slug": "robbie-become-a-beast",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/388a6de949e74563b9e6758908bc2865-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/388a6de949e74563b9e6758908bc2865/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Robbie: Become a Beast",
      "description": "Transform into a wild animal and train to become the fastest and strongest in \"Robbie: Become a Beast\"! \n\n?? Improve your endurance, compete against rivals, and prove you're the best runner. ????‍♂️ Get pets to help you train and increase your chances of winning. ?? Enhance your skills and become faster and stronger with each victory! ?? \n\nAre you ready to be the ultimate beast? Train, compete, and win in \"Robbie: Become a Beast\"! ??",
      "instructions": "On the computer:\nW A S D - to move\nR - to dash\nSpace - to jump\nLeft mouse button - to train\n\nOn the phone:\nUse the joystick and buttons on the screen",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "arcade",
        "competition",
        "pet",
        "run"
      ]
    },
    "zh-CN": {
      "title": "罗比：成为一只野兽",
      "description": "化身为野生动物，在“Robbie：成为野兽”中训练成为最快最强！\n提升你的耐力，与对手竞技，证明你是最佳跑者。🏃‍♂️获得宠物来帮助你训练并提高获胜机会。🐾提升你的技能，每次胜利后变得更快更强！🏆\n你准备好成为终极野兽了吗？在“Robbie：成为野兽”中训练、竞技、获胜！🏆",
      "instructions": "电脑上：\nW A S D - 用于移动\nR - 用于冲刺\n空格键 - 用于跳跃\n左鼠标键 - 用于训练\n\n手机上：\n使用屏幕上的摇杆和按钮",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "街机",
        "竞赛",
        "宠物",
        "跑酷"
      ]
    },
    "zh-TW": {
      "title": "羅比：變成野獸",
      "description": "",
      "instructions": "在電腦上：\nW A S D - 移動\nR - 快跑\n空格鍵 - 跳躍\n左鍵 - 訓練\n\n在電話上：\n使用螢幕上的搖桿和按鈕",
      "genres": [
        "休闲",
        "賽車與駕駛"
      ],
      "tags": [
        "街機",
        "競賽",
        "寵物",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "羅比：變成獸類",
      "description": "變身為野生動物，並在「Robbie: 成為野獸」中接受訓練，成為最快最強的存在！\n提升耐力，與對手競賽，證明你是最佳的長跑選手。🏃♂️\n收養寵物幫助你訓練，增加獲勝機會。？\n提升技能，每戰勝一場就變得更快更强！？\n你準備好成為最強的野獸了嗎？在「Robbie: 成為野獸」中訓練、競賽、獲勝！？",
      "instructions": "在電腦上：\nW A S D - 移動\nR - 跳躍\n空格鍵 - 跳躍\n左鍵 - 開發技能\n\n在手機上：\n使用螢幕上的搖桿及按鈕",
      "genres": [
        "休閒",
        "賽車及駕駛"
      ],
      "tags": [
        "電玩",
        "競賽",
        "寵物",
        "跑酷"
      ]
    },
    "ja": {
      "title": "ロビー：獣になる",
      "description": "",
      "instructions": "パソコン上での操作：\nW A S D - 移動\nR - ダッシュ\nスペース - 跳躍\n左クリックボタン - 訓練\n\nスマートフォン上での操作：\nスクリーンのジョイスティックとボタンを使用",
      "genres": [
        "カジュアル",
        "レーシング＆ドライビング"
      ],
      "tags": [
        "アーケード",
        "コンペ",
        "ペット",
        "ラン"
      ]
    },
    "ko": {
      "title": "로비: 베스트가 되어라",
      "description": "",
      "instructions": "컴퓨터에서:\nW A S D - 이동\nR - dash\n스페이스바 - 점프\n좌클릭 - 훈련\n\n폰에서:\n스크린에 있는 조이스틱과 버튼을 사용합니다.",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "어거트",
        "경쟁",
        "반려동물",
        "달리기"
      ]
    },
    "fr": {
      "title": "Robbie : Deviens une Bête",
      "description": "",
      "instructions": "Sur l'ordinateur :\nW A S D - pour se déplacer\nR - pour foncer\nEspace - pour sauter\nBouton gauche de la souris - pour entraîner\n\nSur le téléphone :\nUtilisez le joystick et les boutons sur l'écran",
      "genres": [
        "Casual",
        "Course et Conduite"
      ],
      "tags": [
        "arcade",
        "compétition",
        "animal de compagnie",
        "course"
      ]
    }
  }
};
